module.exports = __webpack_public_path__ + "static/media/7.9a24f294.webp";